import User from "./User"

export default class Session {

    static #STORAGE = sessionStorage
    static #STORAGE_KEY_SESSIONID = 'twi_sess_id'
    static #STORAGE_KEY_USER = 'twi_sess_user'

    #sessionId = ''
    #user = null

    static restore() {
        const sessionid = Session.#STORAGE.getItem(Session.#STORAGE_KEY_SESSIONID)
        if (typeof sessionid !== 'string') {
            throw new Error('Failed to restore session: No session id stored.')
        }

        const userJson = Session.#STORAGE.getItem(Session.#STORAGE_KEY_USER)
        if (typeof userJson !== 'string') {
            throw new Error('Failed to restore session: No user data stored.')
        }

        try {
            const user = User.fromObject(JSON.parse(userJson))
            return new Session(sessionid, user)
        } catch (err) {
            throw new Error('Failed to restore session from stored data: ' + err)
        }
    }

    static purge() {
        Session.#STORAGE.removeItem(Session.#STORAGE_KEY_SESSIONID)
        Session.#STORAGE.removeItem(Session.#STORAGE_KEY_USER)
    }

    constructor(sessionId, user) {
        if (typeof sessionId !== 'string') {
            throw new Error('Session ID must be a string.')
        }
        if (!(user) instanceof User) {
            throw new Error('User must be a valid object.')
        }

        this.#sessionId = sessionId
        this.#user = user
    }

    persist() {
        Session.#STORAGE.setItem(Session.#STORAGE_KEY_SESSIONID, this.#sessionId)
        Session.#STORAGE.setItem(Session.#STORAGE_KEY_USER, JSON.stringify(this.#user))
    }

    getSessionId() {
        return this.#sessionId
    }

    getUser() {
        return this.#user
    }

}